import type { Order } from '@seen/core/models/orders/Order'
import { StandardTask } from '@seen/core/models/tasks/standard/standardTask'
import { Button } from '@seen/ui'
import { IconPlus } from '@tabler/icons-react'
import type { JSX } from 'react'
import { TaskList } from '#src/components/task/list/TaskList.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'
import { useTaskComposerStore } from '#src/hooks/useTaskComposerStore.ts'

interface OrderTasksProps {
  order: Order
}

export function OrderTasks({ order }: OrderTasksProps): JSX.Element {
  const { data: tasks } = useSearch(
    StandardTask,
    StandardTask.byOrder(order.reference)
  )

  const setOpen = useTaskComposerStore((state) => state.setOpen)
  const setDefaultValues = useTaskComposerStore(
    (state) => state.setDefaultValues
  )

  const handleAddTask = (): void => {
    setOpen(true)
    setDefaultValues({ state: 'todo', focus: order.reference })
  }

  if (tasks?.length === 0) {
    return (
      <div className="flex">
        <Button variant="ghost" onClick={handleAddTask}>
          <IconPlus size={18} className="mr-2" /> Add subtask
        </Button>
      </div>
    )
  }

  return (
    <TaskList
      tasks={tasks}
      defaultValues={{ focus: order.reference }}
      participant={order.participant}
      hideOrder
    />
  )
}
